var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{staticClass:"header"}),_c('OnePage'),_c('TwoPage'),_c('ThreePage',{staticClass:"threePage"}),_c('FourPage',{staticClass:"fourPage"}),_c('EightPage',{staticClass:"eightPage"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }